import Layouts from "./layouts/Layouts";
import Router from "./Routes/Router";

function App() {
  return (
    <div>
      <Layouts>
        <Router />
      </Layouts>
    </div>
  );
}

export default App;
